import { ErrorHandler } from '@src/shared/ui/components/ErrorHandler';
import { Table as TableComponent } from '@src/shared/ui/components/TableQuery';
import { dayjs } from '@uhg-abyss/web/tools/dayjs';
import { merge, orderBy } from 'lodash';
import React, { useMemo } from 'react';

import { ExpansionRow } from './components/ExpansionRow';
import configuration from './includes/configuration.json';

/**
 * Table
 *
 * Displays a list of action paths within a DataTable.
 *
 * @param error
 * @param isLoading
 * @param requestArgs
 * @param requestFunction
 * @param requestKey
 * @param rows
 * @param totalPages
 * @param totalRecords
 * @returns {Element}
 * @constructor
 */
export function Table({
  error = null,
  isLoading = false,
  requestArgs = {},
  requestFunction = null,
  requestKey = '',
  rows = [],
  totalPages = 0,
  totalRecords = 0,
}) {
  /**
   * renderCellChangedDate
   *
   * Displays the changed date cell.
   *
   * @param cell
   * @returns {*}
   */
  const renderCellChangedDate = ({ cell }) => {
    return dayjs(cell?.value).format('MM/DD/YYYY, HH:mm:ss');
  };

  /**
   * renderCellCounts
   *
   * Displays the cell counts.
   *
   * @param cell
   * @returns {string}
   */
  const renderCellCounts = ({ cell }) => {
    return Number(cell?.value).toLocaleString('en-US');
  };

  /**
   * Columns for table.
   *
   * @type {{}[]}
   */
  const columns = useMemo(() => {
    return orderBy(configuration?.initialColumns, ['order'], ['asc']).map((item) => {
      const column = item;

      if (column.Header === 'Changed Date') {
        column.Cell = renderCellChangedDate;
      }

      if (String(column.Header).toLowerCase().includes('count')) {
        column.Cell = renderCellCounts;
      }

      return column;
    });
  }, []);

  return (
    <ErrorHandler location="src/widgets/RiskRecords/TrustedValueHistory/components/Table/Table.jsx">
      <TableComponent
        {...{
          accessor: `eidSearch-trustedValueHistory`,
          columns,
          configuration: merge({}, configuration, {
            renderSubComponent: ({ original }) => {
              return <ExpansionRow row={original} />;
            },
          }),
          error,
          isLoading,
          requestArgs,
          requestFunction,
          requestKey,
          rows,
          totalPages,
          totalRecords,
        }}
      />
    </ErrorHandler>
  );
}
